import imgLocked from "@/Globals/_images/locked.png";
import imgUnlocked from "@/Globals/_images/unlocked.png";

interface ILockIconComponentProp {
    isLocked: boolean;
    onChange: (isLocked: boolean) => void;
}

class LockIconComponent extends React.Component<ILockIconComponentProp, never> {
    public render(): JSX.Element {
        const iconToShow = this.props.isLocked
            ? imgLocked
            : imgUnlocked;

        return (
            <img
                className="lock-icon-component"
                src={iconToShow}
                alt={cacheStore.GetString("RememberLabel")}
                onClick={() => this.props.onChange(!this.props.isLocked)}
            />
        );
    }
}
export { LockIconComponent };
